import Immutable from 'immutable';

const images = Immutable.Map({});

export default images;
